import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import VoucherBatchListScreen from './screens/VoucherBatchListScreen';
import VoucherBatchDetailScreen from './screens/VoucherBatchDetailScreen';

function VoucherBatch(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<VoucherBatchListScreen />} />
                    <Route path="/:voucherBatchId" element={<VoucherBatchDetailScreen />} />
                    {/* <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} />
                    <Route path="/:agencyId/:saleId" element={<AgencySaleDetailScreen />} />
                    <Route path="/coinvestor-info/:agencyId" element={<VoucherPartnerDetailScreen />} />
                    <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
                    <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} /> */}
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default VoucherBatch;
